import type {
  DataExampleDefinition,
  DataSetMetadata,
} from '@robovision/data'


interface DatasetMetadataParams {
  createdAt: string
  description?: string
  exampleDefinition?: DataExampleDefinition
  name: string
  ownerId?: string
  poolId: string
  sampleCount: number
  setId: string
  slug: string
}

export class DatasetMetadata {
  public readonly createdAt: string
  public readonly description?: string
  public readonly exampleDefinition?: DataExampleDefinition
  public readonly name: string
  public readonly ownerId?: string
  public readonly poolId: string
  public readonly sampleCount: number
  public readonly setId: string
  public readonly slug: string

  constructor (params: DatasetMetadataParams) {
    this.createdAt = params.createdAt
    this.description = params.description
    this.exampleDefinition = params.exampleDefinition
    this.name = params.name
    this.ownerId = params.ownerId
    this.poolId = params.poolId
    this.sampleCount = params.sampleCount
    this.setId = params.setId
    this.slug = params.slug
  }

  public static fromResponse (data: DataSetMetadata) {
    return new DatasetMetadata({
      createdAt: data.createdAt,
      description: data.description,
      exampleDefinition: data.exampleDefinition,
      name: data.name,
      ownerId: data.ownerId,
      poolId: data.poolId,
      sampleCount: data.sampleCount,
      setId: data.setId,
      slug: data.slug,
    })
  }
}
